// Hook pour gérer le formatage du texte
export const useFormatting = ({ editContent, setEditContent }) => {
  
  // Fonctions de formatage simples
  const applySimpleFormat = (format) => {
    // Utiliser une référence directe au textarea
    const textarea = document.querySelector('textarea[class*="editor"]') || document.querySelector('textarea');
    
    if (!textarea) {
      console.warn('Textarea non trouvé pour le formatage');
      return;
    }
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = editContent.substring(start, end);
    
    let formattedText = '';
    
    switch(format) {
      case 'bold':
        formattedText = `**${selectedText}**`;
        break;
      case 'italic':
        formattedText = `*${selectedText}*`;
        break;
      case 'h2':
        formattedText = `## ${selectedText}`;
        break;
      case 'h3':
        formattedText = `### ${selectedText}`;
        break;
      case 'ul':
        formattedText = `- ${selectedText}`;
        break;
      case 'ol':
        formattedText = `1. ${selectedText}`;
        break;
      default:
        formattedText = selectedText;
    }
    
    const newContent = editContent.substring(0, start) + formattedText + editContent.substring(end);
    setEditContent(newContent);
    
    // Remettre le focus sur le textarea après la modification
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + formattedText.length, start + formattedText.length);
    }, 0);
  };

  return { applySimpleFormat };
};
